import { apiFetch } from './auth';

export interface AppNotification {
  id: number;
  user_id: number;
  title: string;
  body: string;
  type: string;
  is_read: boolean;
  created_at: string;
  updated_at: string;
}

export interface NotificationsResponse {
  notifications: AppNotification[];
  total: number;
}

export type NotificationStatus = 'read' | 'unread';

async function handle<T>(res: Response, fallback: string): Promise<T> {
  if (!res.ok) {
    let message = `${fallback} (${res.status})`;
    try {
      const body = await res.json();
      if (body?.message) message = body.message;
      else if (body?.error) message = body.error;
    } catch {
      /* ignore */
    }
    throw new Error(message);
  }
  return res.json() as Promise<T>;
}

export async function getNotifications(
  status?: NotificationStatus
): Promise<NotificationsResponse> {
  const query = status ? `?status=${status}` : '';
  const res = await apiFetch(`/api/v1/notifications${query}`);
  return handle(res, 'Failed to load notifications');
}

export async function markNotificationRead(id: number): Promise<AppNotification> {
  const res = await apiFetch(`/api/v1/notifications/${id}/read`, { method: 'PATCH' });
  return handle(res, 'Failed to mark notification as read');
}
